
import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { clearReagentsCache } from "@/services/reagents/fetchReagents";
import { Reagent } from "@/types/reagent.types";

/**
 * Hook for managing reagent cache
 */
export const useReagentCache = (userId: string | undefined, reagents: Reagent[]) => {
  const queryClient = useQueryClient();

  // Clear cache on component mount for fresh data
  useEffect(() => {
    // Only clear cache if user is logged in to avoid flashing empty state
    if (userId) {
      clearReagentsCache();
    }
  }, [userId]);

  // Fallback to cached data if available
  useEffect(() => {
    if (reagents.length === 0 && userId) {
      const latestReagents = queryClient.getQueryData(['latestReagents']);
      if (latestReagents && Array.isArray(latestReagents) && latestReagents.length > 0) {
        console.log("Using latestReagents data as fallback");
        queryClient.setQueryData(['reagents'], latestReagents);
      }
    }
  }, [reagents.length, userId, queryClient]);
};
